<template>
    <ui-modal
        title="Call Tracking - Compra de números"
        icon="fal fa-phone-volume"
        name="marketing-queues-call-tracking"
        size="md"
    >
        <template #footer>
            <div class="select-info">
                <span>
                    Você selecionou
                    <span class="color-success">{{ form.selecteds.length }} de {{ form.numbersCanBuy }}</span>
                    números
                </span>
            </div>
            <ui-button :disabled="disabledSubmitButton" design="lg success mw-150" @click="submit">Confirmar Compra</ui-button>
        </template>

        <div class="call-tracking">
            <div class="box call-tracking-left">
                <div class="call-tracking-header">
                    <ui-search-box
                        v-model="form.search"
                        event="marketing-queues-call-tracking-search"
                        mask="(##)"
                        :disabled-button="disabledSearchButton || loader"
                        :clear-text-when-sending="true"
                        placeholder="Digite o DD desejado"
                    >
                        <template #label>Buscar</template>
                    </ui-search-box>
                </div>

                <div v-show="!form.data.length" class="call-tracking-no-content">
                    <div class="caption">
                        <ui-overlay-load v-if="loader" />
                        <div class="title">
                            Utilize o campo acima para encontrar os números com o <b>DD</b> desejado.
                        </div>
                    </div>
                </div>

                <div v-show="form.data.length" ref="scroller" class="call-tracking-content scroll-color">
                    <ui-overlay-load v-if="loader" />
                    <div class="select-phone">
                        <table class="select-phone-table">
                            <tr v-for="(i, index) in form.data" :key="index" class="select-phone-line">
                                <td class="id">{{ index + 1 }}</td>
                                <td class="number">{{ maskPhone(i.friendlyName) }}</td>
                                <td class="city">{{ i.City }}</td>
                                <td class="action">
                                    <ui-button
                                        design="sm green"
                                        :disabled="form.selecteds.length >= form.numbersCanBuy"
                                        @click="addNumber(index)"
                                    >
                                        <i class="fal fa-plus"/>
                                    </ui-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-if="showSelectPhoneLoadMore" class="add-more-number">
                        <ui-button design="md line block" @click="loadMorePhone">Carregar mais números</ui-button>
                    </div>
                    <div v-if="showSelectPhoneLoading" class="load-indicator">
                        <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
                    </div>
                </div>
            </div>

            <div class="box call-tracking-right">
                <div class="call-tracking-header">
                    <i class="fal fa-shopping-cart"/>
                    <div class="title">Números Selecionados</div>
                </div>

                <div v-if="form.selecteds.length === 0" class="call-tracking-no-content">
                    <div class="caption">
                        <div class="title">Você ainda não selecionou nenhum <b>número</b> para compra.</div>
                    </div>
                </div>

                <div v-else class="call-tracking-content">
                    <div class="numbers-list">
                        <div v-for="(i, index) in form.selecteds" :key="index" class="numbers-list-item">
                            <div class="number">
                                {{ maskPhone(i.number) }} - <span class="color-success">{{ i.city }}</span>
                            </div>
                            <ui-button design="xs danger" @click="removeNumber(index)">Remover</ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiButton } from '@/components/ui/buttons'
    import { uiSearchBox, uiLoadIndicator, uiOverlayLoad } from '@/components/ui'

    import { integration } from '@/services/axios'

    export default {
        components: {
            uiModal,
            uiButton,
            uiSearchBox,
            uiLoadIndicator,
            uiOverlayLoad,
        },

        data() {
            return {
                disabledSearchButton: true,
                showSelectPhoneLoadMore: false,
                showSelectPhoneLoading: false,
                loader: false,
                offeset: 0,

                form: {
                    limitNumbers: 0,
                    numbersCanBuy: 0,
                    search: '',
                    lastSearch: '',
                    data: [],
                    selecteds: [],
                },
            }
        },

        computed: {
            search() {
                return this.form.search
            },

            disabledSubmitButton() {
                return !(this.form.selecteds.length > 0)
            }
        },

        watch: {
            search(val) {
                const search = val.replace(/["'()]/g,"")

                if (search.length === 2 && this.form.numbersCanBuy > 0) {
                    this.disabledSearchButton = false
                }
                if (search.length < 2) {
                    this.disabledSearchButton = true
                }
            },
        },

        mounted() {
            this.$refs.scroller.addEventListener('scroll', this.scrollHandler)

            this.$root.$on('modal-open-marketing-queues-call-tracking', (data) => {
                this.$set(this.form, 'numbersCanBuy', data)
            })

            this.$root.$on('marketing-queues-call-tracking-search', () => {
                this.getData()
            })
            /**
             * esse evento é para ativar no componente pai a opção de remover número selecionado
             */
            this.$root.$on('remove-number-event', this.removeNumber)
        },

        beforeDestroy() {
            this.$root.$off('modal-open-marketing-queues-call-tracking')
            this.$root.$off('marketing-queues-call-tracking-search')

            this.$root.$off('remove-number-event', this.removeNumber)
        },

        methods: {
            submit() {
                this.$root.$emit('modal-close-marketing-queues-call-tracking')
                this.$root.$emit('modal-calltrack-select-number-resolve', this.form.selecteds)
            },

            addNumber(id) {
                this.form.selecteds.push({
                    id: id,
                    name: this.form.data[id].Number,
                    provider_number: this.form.data[id].Number,
                    provider: this.form.data[id].type,
                    city: this.form.data[id].City,
                    number: this.form.data[id].friendlyName
                })
                this.form.data.splice(id, 1)
            },

            removeNumber(id) {
                this.form.data.push({
                    id: id,
                    Number: this.form.selecteds[id].name,
                    type: this.form.selecteds[id].provider,
                    City: this.form.selecteds[id].city,
                    friendlyName: this.form.selecteds[id].number
                })
                this.form.selecteds.splice(id, 1)
            },

            /**
             * Ouve o evento de scroll e emit um evento 'load-more' assim que
             * chega ao final da tela. Apenas da parte central, onde fica a tabela.
             * Usado para fazer scroll infinito.
             */
            scrollHandler(event) {
                const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight
                if (bottom) {
                    this.showSelectPhoneLoadMore = true
                }
            },

            loadMorePhone() {
                this.getData(true)
            },

            maskPhone(value) {
                if (!value) return ''

                let str = value.replace(/\D/g, '').replace(/^0/, '')

                if (str.length > 10) {
                    return str.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3')
                } else if (str.length > 5) {
                    return str.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3')
                } else if (str.length > 2) {
                    return str.replace(/^(\d\d)(\d{0,5})/, '$1-$2')
                } else {
                    return str.replace(/^(\d*)/, '($1')
                }
            },

            getData(isButtonAdd = false) {
                if (this.disabledSearchButton && !isButtonAdd) return 
                
                this.showSelectPhoneLoadMore = false
                this.showSelectPhoneLoading = true

                if (isButtonAdd && this.form.lastSearch) {
                    this.offset += this.offset < 19 ? 19 : 20
                } else {
                    this.offset = 0
                }

                const search = this.form.search.replace(/["'()]/g,"")
                const lastSearch = this.form.lastSearch.replace(/["'()]/g,"")

                if (!search && !isButtonAdd) {
                    this.showSelectPhoneLoading = false
                    this.loader = false 
                    return;
                }

                this.loader = true

                integration
                    .getAll(`voice/listNumbers/${isButtonAdd ? lastSearch : search}?limit=20&offset=${this.offset == 0 ? '' : this.offset}`)
                    .then((response) => {
                        if (response.data.result) {
                            if (isButtonAdd) {
                                this.$set(this.form, 'data', this.form.data.concat(response.data.result))
                            }else{
                                this.$set(this.form, 'data', response.data.result)
                            }
                        }else{
                            this.$set(this.form, 'data', [])
                        }
                    })
                    .catch((error) => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
                    .finally(() => {
                        if(!isButtonAdd) {
                            this.$set(this.form, 'lastSearch', this.form.search)
                        }
                        this.$set(this.form, 'search', '')
                        this.showSelectPhoneLoading = false
                        this.loader = false
                    })
            },

            numbersCanBuy(){
                integration
                    .getAll('voice/numbersCanBuy')
                    .then(response => {
                        this.$set(this.form, 'numbersCanBuy', response.data)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
